<template>
    <div>
        <modal class="new-manager" :display="modalStatus.bizNewManager" @modalStatus="closeModal" >
            <h1>{{type==='CHARTER'?'新增租賃住宅管理人員':'新增不動產經紀人'}}</h1>
            <div class="new-manager-wrap">
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                             姓名
                        </div>
                        <span v-show="error.managerName" class="error-with-title">{{error.managerName}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.managerName}" type="text" v-model="contractSetting.managerName" placeholder="請輸入姓名">
                    </div>
                </div>
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                             證書字號
                        </div>
                        <span v-show="error.certificateNum" class="error-with-title">{{error.certificateNum}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.certificateNum}" type="text" v-model="contractSetting.certificateNum" placeholder="請輸入證書字號">
                    </div>
                </div>
                <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                             聯絡電話
                        </div>
                        <span v-show="error.managerTel" class="error-with-title">{{error.managerTel}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.managerTel}" type="text" v-model="contractSetting.managerTel" placeholder="請輸入聯絡電話">
                    </div>
                </div>
                <div>
                    <label class="button-font input-label">
                        <div class="title">
                            地址
                        </div>
                        <span v-show="error.address" class="error-with-title">{{error.address}}</span>
                    </label>
                    <div class="input-error-group">
                        <div class="couty-group">
                            <rent-select :key="'city'+componentKey" :class="{error: error.managerCityCid}" class="select-scroll biz county" refName="county" :selectMsg="address.county.msg" :isEdit="address.county.msg!=='縣市'" @getId="getSelectId" bgColor="#fff" :setDefault="address.county.state">
                                <ul>
                                    <li v-for="(county, index) in counties" :key="index" :data-id="index">
                                        {{county}}
                                    </li>
                                </ul>
                            </rent-select>
                            <rent-select :key="'district'+componentKey" :class="{error: error.managerDistrictCid}" class="select-scroll biz district" refName="district" :selectMsg="address.district.msg" :isEdit="address.district.msg!=='區域'" @getId="getSelectId" bgColor="#fff" :setDefault="address.district.state">
                                <ul>
                                    <li v-for="(district, index) in districts" :key="index" :data-id="district.districtCid">
                                        {{district.districtName}}
                                    </li>
                                </ul>
                            </rent-select>
                            <rent-select-filter :class="{error: error.managerRoadCid}" class="rent-select-filter select-scroll  select-road road biz" refName="road" :selectMsg="address.road.msg" :isEdit="address.road.msg!=='路名'" @getId="getSelectId" bgColor="#fff" :setDefault="address.road.state">
                                <div class="select-filter">
                                    <img class="search" src="@/assets/img/icon/search_black.svg" alt="">
                                    <input v-model="address.road.selectedRoad" placeholder="搜尋路段" type="text">
                                </div>
                                <ul>
                                    <li v-for="(road, index) in filterRoad" :key="index" :data-id="road.roadStreetCid">
                                        {{road.roadStreetName}}
                                    </li>
                                </ul>
                            </rent-select-filter>
                        </div>
                        <input :class="{error: error.managerAddress}" type="text" v-model="contractSetting.managerAddress" placeholder="請輸入地址">
                    </div>
                </div>
                <!-- <div class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                             電子郵件信箱
                        </div>
                        <span v-show="error.managerMail" class="error-with-title">{{error.managerMail}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.managerMail}" type="text" v-model="contractSetting.managerMail" placeholder="請輸入電子郵件信箱">
                    </div>
                </div> -->
                <div class="image-cover">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill"></span>
                            上傳簽名
                        </div>
                        <div class="control-btn-wrap">
                            <file-upload
                                v-if="managerSignature.upload.length || managerSignature.preview"
                                class="replace"
                                post-action="/upload/post"
                                input-id="manager-signature"
                                :size="1024 * 5"
                                :maximum="1"
                                :multiple="true"
                                :drop="true"
                                :drop-directory="true"
                                v-model="managerSignature.upload"
                                @input-file="inputFile"
                                @input-filter="inputFilter"
                                ref="uploadCover">
                                    取代圖片
                            </file-upload>
                        </div>
                    </label>
                    <div class="input-error-group">
                        <div v-if="!managerSignature.upload.length && !managerSignature.preview" class="cover-block" :class="{'img-error': error.managerSignature}">
                            <file-upload
                            class="upload-btn"
                            post-action="/upload/post"
                            input-id="manager-signature"
                            :size="1024 * 5"
                            :maximum="1"
                            :multiple="true"
                            v-model="managerSignature.upload"
                            @input-file="inputFile"
                            @input-filter="inputFilter"
                            ref="uploadCover">
                                <img class="upload-icon" src="@/assets/img/icon/upload_biz.svg" alt="">
                                上傳圖片
                            </file-upload>
                        </div>
                        <div v-else class="cover-preview">
                            <div class="preview">
                                <img v-show="flag.isResize" ref="sinature" :src="managerSignaturePreviewImg" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn-group">
                <button class="default-button confirm" @click="saveContractSetting()" :disabled="isAllEmpty">確認</button>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import RentSelect from '@/components/bussiness/widges/tools/RentSelect.vue';
import RentSelectFilter from '@/components/bussiness/widges/tools/RentSelectFilter.vue';
import FileUpload from 'vue-upload-component';
import { mapGetters } from 'vuex'
import { 
    setRentalAgent,
    setEstateAgent,
    } from "@/apis/company/contractSetting.js"; 
const defaultParams = {
    managerId: null,
    managerName:'',
    managerAddress: '',
    managerCityCid: '',
    managerDistrictCid: '',
    managerRoadCid: '',
    managerTel: '',
    managerMail: '',
    managerSignature: '',
    certificateNum: '',
}
export default {
    data () {
        return {
            componentKey: 0,
            contractSetting: JSON.parse(JSON.stringify(defaultParams)),
            error: JSON.parse(JSON.stringify(defaultParams)),
            managerSignature: {
                preview: null,
                upload: []
            },
            address: {
                county: {
                    state: false,
                    msg: '縣市'
                },
                district: {
                    state: false,
                    msg: '區域'
                },
                road: {
                    state: false,
                    msg: '路名',
                    selectedRoad: null
                }
            },
            flag: {
                isWidth: true,
                signatureIsWidth: true,
                isResize: false
            }
        }
    },
    props: {
        type: String,
        isEdit: Boolean,
        editObj: Object
    },
    watch: {
        contractSetting: {
            handler: function(val) {
                //租賃住宅管理人員-姓名
                if(val.managerName){
                    if(this.checkStringLessThanNum(val.managerName, 20)){
                        this.error.managerName = null
                    }else{
                        this.error.managerName = '需少於20字'
                    }
                }
                //租賃住宅管理人員-證書字號
                if(val.certificateNum){
                    if(this.checkStringLessThanNum(val.certificateNum, 20)){
                        this.error.certificateNum = null
                    }else{
                        this.error.certificateNum = '需少於20字'
                    }
                }
                //租賃住宅管理人員-聯絡電話
                if(val.managerTel){
                    if(this.checkStringLessThanNum(val.managerTel, 20)){
                        this.error.managerTel = null
                    }else{
                        this.error.managerTel = '需少於20字'
                    }
                }
            },
            deep: true
        },
        'managerSignature.upload': function (val){
            if(val.length > 0){
                let reader = new FileReader();
                reader.readAsDataURL(val[0].file)
                setTimeout(()=>{
                    console.log('reader.result'+reader.result)
                    this.contractSetting.managerSignature = reader.result
                    this.getImageWidthAndHeight(reader.result, 'sinature')
                }, 500)
            }
        },
        isEdit: function (val) {
            if(val){
                if(this.editObj.managerId){
                    this.contractSetting.managerId = this.editObj.managerId
                }
                if(this.editObj.managerName){
                    this.contractSetting.managerName = this.editObj.managerName
                }
                if(this.editObj.managerSignature){
                    this.managerSignature.preview = this.editObj.managerSignature
                    this.getImageWidthAndHeight(this.editObj.managerSignature, 'sinature')

                }
                if(this.editObj.managerTel){
                    this.contractSetting.managerTel = this.editObj.managerTel
                }
                if(this.editObj.certificateNum){
                    this.contractSetting.certificateNum = this.editObj.certificateNum
                }
                if(this.editObj.city){
                    this.address.county.msg = this.editObj.city.cityName
                }
                if(this.editObj.district){
                    this.address.district.msg = this.editObj.district.districtName
                }
                if(this.editObj.road){
                    this.address.road.msg = this.editObj.road.roadStreetName
                }
                if(this.editObj.address){
                    this.contractSetting.managerAddress = this.editObj.address
                }
            }
        }
    },
    methods: {
        getSelectId: function (value) {
            // console.log(value)
            let targetId = parseInt(event.target.dataset.id)
            if ( value.ref == 'county' ){
                //區域及縣市變為預設
                this.address.district.state = true
                this.address.road.state = true
                this.address.district.msg = '區域'
                this.address.road.msg = '路段'
                this.contractSetting.managerDistrictCid = ''
                this.contractSetting.managerRoadCid = ''
                this.contractSetting.managerCityCid = targetId+1
                this.$store.dispatch('getDistrict',(targetId+1))
            }else if ( value.ref == 'district' ){
                this.address.road.state = true
                this.address.road.msg = '路段'
                this.address.district.state = false
                this.contractSetting.managerRoadCid = ''
                this.contractSetting.managerDistrictCid = targetId
                this.$store.dispatch('getRoad',(targetId))
            }else if ( value.ref == 'road' ){
                this.address.road.state = false

                this.contractSetting.managerRoadCid = targetId
            }
        },
        inputFile: function (newFile, oldFile) {
            if (newFile && oldFile && !newFile.active && oldFile.active) {
                // Get response data
                if (newFile.xhr) {
                //  Get the response status code
                // console.log('status', newFile.xhr.status)
                }
            }
        },
        inputFilter: function (newFile, oldFile, prevent) {
                console.log('response', newFile)
            
            if (newFile && !oldFile) {
                // Filter non-image file
                if (!/\.(jpeg|jpe|jpg|png)$/i.test(newFile.name)) {
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '請上傳JPG或PNG檔案',type: 'error'})
                    return prevent()
                }

                if(newFile.size > (1024*1024*5)){
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '檔案最大限制5MB',type: 'error'})
                    return prevent()
                }
            }
            // console.log(newFile)
            // Create a blob field
            newFile.blob = ''
            let URL = window.URL || window.webkitURL
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file)
            }
            
        },
        getImageWidthAndHeight: function (val, type) {
            let newImg = new Image()
            newImg.src = val
            let hRatio;
            let wRatio;
            let Ratio = 1;
            
            setTimeout(()=>{
                let w = newImg.width;
                let h = newImg.height;
                wRatio = 400 / w;
                hRatio = 200 / h;
                if (wRatio<1 || hRatio<1){
                    Ratio = (wRatio<=hRatio?wRatio:hRatio);
                }
                if (Ratio<1){
                    w = w * Ratio;
                    h = h * Ratio;
                }
                
                this.$refs[type].width = w
                this.$refs[type].height = h
                this.flag.isResize = true
            }, 500)
        },
        saveContractSetting: function () {
            const data = this.contractSetting
            console.log(data)
            let formData = new FormData();
            console.log(this.contractSetting.managerId)
            if(this.contractSetting.managerId){
                formData.append('managerId', this.contractSetting.managerId);
            }
            formData.append('managerName', this.contractSetting.managerName);
            formData.append('certificateNum', this.contractSetting.certificateNum);
            formData.append('managerAddress', this.contractSetting.managerAddress);
            formData.append('managerCityCid', this.contractSetting.managerCityCid);
            formData.append('managerDistrictCid', this.contractSetting.managerDistrictCid);
            formData.append('managerRoadCid', this.contractSetting.managerRoadCid);
            formData.append('managerTel', this.contractSetting.managerTel);
            formData.append('managerSignature', this.contractSetting.managerSignature);

            if(this.type === 'CHARTER'){
                setRentalAgent(formData)
                .then(res => {
                    console.log(res)
                    if( res.data.status == "SUCCESS" ){
                        this.$store.dispatch('setAlarmStatus', {status: true,title: '企業合約設定儲存成功',type: 'success'})
                        this.$emit('update')
                    }else{
                        this.$store.dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                    }
                })
                .catch(err => {
                    console.log(err)
                })
            }else if(this.type === 'ESCROW'){
                setEstateAgent(formData)
                .then(res => {
                    console.log(res)
                    if( res.data.status == "SUCCESS" ){
                        this.$store.dispatch('setAlarmStatus', {status: true,title: '企業合約設定儲存成功',type: 'success'})
                        this.$emit('update')
                    }else{
                        this.$store.dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                    }
                })
                .catch(err => {
                    console.log(err)
                })
            }else{
                this.$store.dispatch('setAlarmStatus', {status: true,title: '無法辨別新增類型',type: 'error'})
                let data = {
                    accessToken : localStorage.getItem('token'),
                    channel : this.$route.meta.channel,
                    apiUrl : null,
                    reqParam : null,
                    errDesc : '無法辨別新增類型'
                }
                this.$store.dispatch('sendErrorLog', data)
            }
            this.closeModal()
        },
        setDefault: function () {
            this.contractSetting = JSON.parse(JSON.stringify(defaultParams))
            this.error = JSON.parse(JSON.stringify(defaultParams))
            this.managerSignature.preview = null
            this.managerSignature.upload = []
            this.address = {
                county: {
                    state: false,
                    msg: '縣市'
                },
                district: {
                    state: false,
                    msg: '區域'
                },
                road: {
                    state: false,
                    msg: '路名',
                    selectedRoad: null
                }
            }
            if(this.isEdit){
                this.$emit('editSaved')
            }
        },
        closeModal: function (type) {
            this.$store.dispatch('setModalStatus', {state: false, type: 'bizNewManager'})
            this.setDefault()
        },
    },
    computed: {
        isAllEmpty: function () {
            const obj = this.contractSetting
            let flag = true
            for (const key in obj) {
                if (Object.hasOwnProperty.call(obj, key)) {
                    const element = obj[key];
                    console.log(element)
                    if(element){
                        flag = false
                    }
                }
            }
            return flag
        },
        managerSignaturePreviewImg: function () {
            if( this.managerSignature.upload.length > 0){
                return this.managerSignature.upload[0].blob
            }else if( this.managerSignature.preview ){
                return this.managerSignature.preview
            }
        },
        filterRoad: function () {
            return this.roads.filter((road) => {
                // console.log(road.roadStreetName)
                if( this.address.road.selectedRoad ){
                    if(road.roadStreetName.includes(this.address.road.selectedRoad)){
                        return road
                    }
                }else{
                    return road
                }
            });
        },
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
            counties: 'COUNTY_RESULT',
            districts: 'DISTRICTS_RESULT',
            roads: 'ROAD_RESULT',
        })
    },
    components: {
        Modal,
        RentSelect,
        RentSelectFilter,
        FileUpload
    }
}
</script>
<style lang="scss"  >
    #modal.new-manager{
        .modal-content{
            width: 888px;
            height: 600px;
            padding: 0 !important;
            .detail{
                align-items: flex-start;
                >h1{
                    width: 320px;
                    text-align: center;
                    font-size: 24px;
                    margin: 32px auto;
                    line-height: 1.5;
                }
                .new-manager-wrap{
                    padding: 0px 32px;
                    margin-bottom: 20px;
                    >div{
                        width: 384px;
                        margin-bottom: 24px;
                        .couty-group{
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            margin-bottom: 8px;
                            .county,
                            .district{
                                width: 86px;
                            }
                            .road{
                                width: 140px;
                                input{
                                    width: 140px;
                                }
                            }
                            .error{
                                bottom: unset;
                            }
                        }
                    }
                    .image-cover{
                        position: absolute;
                        top: 100px;
                        right: 52px;
                        margin-bottom: 30px;
                        .control-btn-wrap{
                            position: absolute;
                            right: -17px;
                            top: -19px;
                        }
                        .replace{
                            width: 74px;
                            height: 32px;
                            border-radius: 4px;
                            border: solid 1px #e0dfde;
                            background: #fff;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                        .cover-block{
                            position: relative;
                            width: 400px;
                            height: 200px;
                            border-radius: 4px;
                            border: solid 1px #cacfcd;
                            background-color: #ffffff;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            img{
                                margin-bottom: 4px;
                            }
                            .upload-btn{
                                width: 100%;
                                height: 100%;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                justify-content: center;
                            }
                            .img-error{
                                position: absolute;
                                width: 200px;
                                left: 136px;
                                font-weight: 500;
                                font-size: 12px;
                                color:  #F05A3E;
                                top: unset;
                            }
                        }
                        .cover-block.img-error{
                            border: dashed 1px #F05A3E;
                        }
                        .cover-preview{
                            display: flex;
                            align-items: flex-start;
                            width: 500px;
                            .preview{
                                width: 400px;
                                height: 200px;
                                display: flex;
                                margin-right: 10px;
                                align-items: center;
                                justify-content: center;
                                border-radius: 4px;
                                border: solid 1px #cacfcd;
                                // overflow: hidden;
                            }
                        }
                    }
                }
            }
            .btn-group{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 84px;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                border-radius:  0 0 20px 20px;
                margin: 0 auto;
                button{
                    width: 160px;
                    height: 44px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/settingCenter/contractSetting/newManager.vue